import React from 'react'
import { useLocation } from 'react-router-dom'
import { EMBEDDED_INTERVIEW_PATH, IFRAME_VIEW_PATH } from "app-constants"
import { Intercom } from "./intercom"
import { connect } from 'react-redux'


interface IntercomWrapperProps {
  showIntercom?: boolean
  language?: string
  user?: any
  actionBarHeight?: number
}

const IntercomWrapper = ({
  showIntercom,
  language,
  user,
  actionBarHeight,
}: IntercomWrapperProps) => {
  const { pathname } = useLocation()
  const isLiveInterviewPath =
    pathname &&
    (pathname.includes('/live-interview/') || pathname.includes('recordings'))

  const renderSupport = !(
    pathname &&
    (pathname.includes(IFRAME_VIEW_PATH) ||
      pathname.includes(EMBEDDED_INTERVIEW_PATH) ||
      isLiveInterviewPath)
  )
  if (!renderSupport) {
    return null
  }
  return (
    <Intercom
      pathname={pathname}
      language={language}
      showIntercom={showIntercom}
      currentUser={user}
      actionBarHeight={actionBarHeight}
    />
  )
}
export default connect((state: any) => ({
  language: state.global.language,
  showIntercom: state.global.showIntercom,
  actionBarHeight: state.global.actionBarHeight,
  user: state.global.session.user,
}))(IntercomWrapper)